var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { SeparatorContainer, StyledSeparator, StyledLine, SeparatorText } from './style';
var SeparatorWithText = function (_a) {
    var text = _a.text, restProps = __rest(_a, ["text"]);
    return (React.createElement(SeparatorContainer, __assign({}, restProps),
        React.createElement(StyledLine, { width: 30 }),
        React.createElement(SeparatorText, __assign({ tag: "span", variant: "caption" }, restProps), text),
        React.createElement(StyledLine, { width: 1 })));
};
var Separator = function (props) {
    var text = props.text;
    return text ? React.createElement(SeparatorWithText, __assign({}, props)) : React.createElement(StyledSeparator, __assign({}, props));
};
Separator.defaultProps = {
    text: '',
};
export default Separator;
